import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

//export const Schema = (settings) => Yup.object().shape({
export const Schema = Yup.object().shape({
        salaryRequestFrom: Yup.number()
        .typeError("Ungültige Zahl")
        .positive()
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
    salaryRequestTo: Yup.number()
        .typeError("Ungültige Zahl")
        .positive()
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val < 999999999;
            return true;
        })
        .required("Angabe ist erforderlich"),
});

export const SchoolEducationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
            <Form.Group as={Col} controlId="formSchoolEducation">
                    <Form.Label>Voraussichtlicher Schulabschluss bei Ausbildungsbeginn</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="schoolEducation"
                        value={values.schoolEducation}
                        isValid={touched.schoolEducation && !errors.schoolEducation}
                        isInvalid={touched.schoolEducation && errors.schoolEducation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.SchoolEducation.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.schoolEducation}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};